import React, { useState } from 'react';
import { Button, Form, Input, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const Login = ({ children }) => {
  const [password, setPassword] = useState('');

  
  if (password === "Bunny949!") {
    return children;
  }

  return (
    <div className="login-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '200px' }}>
      <Form
        name="basic"
        initialValues={{ remember: true }}
      >
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Item>

      </Form>
    </div>
  );
};

export default Login;
